import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

import PhoneIcon from "@material-ui/icons/Phone";
import FavoriteIcon from "@material-ui/icons/Favorite";
import PersonPinIcon from "@material-ui/icons/PersonPin";

import Sets from "../shared/Sets";
import CollectionNames from "../shared/CollectionNames";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import LanguageNames from "../shared/LanguageNames";

// const useStyles = makeStyles({
//   list: {
//     //  width: 250,
//   },
//   myul: {
//     //  maxHeight: 700,
//     // overflowY:'scroll',
//     //overflow-y: scroll,
//   },
//   limit: {
//     width: 100
//   },
//   myDrawer: {
//     width: 250
//     // width:150
//   },
//   fullList: {
//     width: "auto"
//     //    maxWidth:200
//   }
// });

const drawerWidth = 250;
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  toolbar: theme.mixins.toolbar
}));

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

export default function GrammarSwipeableTemporaryDrawer(props) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    language: "Spanish",
    languages: [{ name: "Spanish" }, { name: "French" }]
  });

  function handleLanguageChange(name) {
    setState({
      ...state,
      language: name
    });
    props.handleSetChange(name);
  }

  function handleChange(e) {
    setState({
      ...state,
      [e.target.id]: e.target.value
    });
  }

  function handleTabChange(event, newValue) {
    // alert(newValue);
    setState({
      ...state,
      tab: newValue
    });
    //setValue(newValue);
  }

  const nav_links = [
    { id: 1, name: "Possesive pronuns" },
    { id: 2, name: "Adjective comparisons" },
    { id: 3, name: "Demostrative pronuns" },
    { id: 4, name: "Conditional" },
    { id: 5, name: "Y ad EN" },
    { id: 6, name: "bien vs bon" },
    { id: 7, name: "mieux vs meilleur" }
  ];

  const toggleDrawer = (side, open) => event => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  function handleBookmarkFilter(event) {
    props.handleBookmarkFilter(event);
  }

  function clickLinks(Name) {
    props.clickLinks(Name);
  }

  const sideList = (side, sets) => (
    <div className={classes.list} role="presentation">
      <List className={classes.myul}>
        {typeof sets != "undefined" &&
          sets.map(se => (
            <ListItem button key={se.name} onClick={() => clickLinks(se.id)}>
              <ListItemText primary={se.name} />
            </ListItem>
          ))}
      </List>
      <Divider />
    </div>
  );

  return (
    <div>
      {/* <Button onClick={toggleDrawer('left', true)}>Open Left</Button> */}

      <div hidden id="main_button_helper" onClick={toggleDrawer("left", true)}>
        Open left
      </div>

      <SwipeableDrawer
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper
        }}
        anchor="left"
        open={state.left}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        <div className={classes.myDrawer}>
          <Container fixed>
            <br></br>

            {sideList("left", nav_links)}
          </Container>
        </div>
      </SwipeableDrawer>
    </div>
  );
}
